export var PRODUCT_NAV_WIDTH = 270;
export var GLOBAL_NAV_WIDTH = 64;
export var NAVIGATION_CHANNEL = 'navigation';